import apiClient from "../api-client.js";

/**
 * Client metrics endpoints.
 *
 * PageSpeed runs on a Celery worker: `queuePageSpeedAudit` queues the audit and
 * the caller polls the generic task-status endpoint. The backend keeps the last
 * audit of each month, so the panel asks for that snapshot on entry instead of
 * caching anything in the browser.
 */

export const queuePageSpeedAudit = async (clientId, strategy, url) => {
  const response = await apiClient.get(`/integrations/pagespeed/${clientId}/audit/`, {
    params: { strategy, url },
  });
  return response.data;
};

/**
 * This month's stored audit, `{ period_date, audit }` with both null when no
 * audit was run during the month yet.
 */
export const getPageSpeedSnapshot = async (clientId) => {
  const response = await apiClient.get(`/integrations/pagespeed/${clientId}/snapshot/`);
  return response.data;
};

// Auditorías web: el backend limita las de cada cliente al mes y responde 409 `audit_limit`.
export const getSiteAudits = async (clientId) => {
  const response = await apiClient.get(`/integrations/site-audits/${clientId}/`);
  return response.data;
};

export const launchSiteAudit = async (clientId, payload) => {
  const response = await apiClient.post(`/integrations/site-audits/${clientId}/launch/`, payload);
  return response.data;
};

export const getSiteAuditReport = async (clientId, auditId) => {
  const response = await apiClient.get(`/integrations/site-audits/${clientId}/report/`, {
    params: { audit: auditId },
  });
  return response.data;
};

export const getSiteAuditIssuePages = async (clientId, auditId, code, offset = 0) => {
  const response = await apiClient.get(`/integrations/site-audits/${clientId}/issue-pages/`, {
    params: { audit: auditId, code, offset },
  });
  return response.data;
};

export const getSiteAuditPages = async (clientId, auditId, offset = 0) => {
  const response = await apiClient.get(`/integrations/site-audits/${clientId}/pages/`, {
    params: { audit: auditId, offset },
  });
  return response.data;
};
